import { render, staticRenderFns } from "./p-cards.vue?vue&type=template&id=79ab635d&scoped=true&"
import script from "./p-cards.vue?vue&type=script&lang=js&"
export * from "./p-cards.vue?vue&type=script&lang=js&"
import style0 from "./p-cards.vue?vue&type=style&index=0&id=79ab635d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ab635d",
  null
  
)

export default component.exports